import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ProcesoAnualidadComponent from "../../../components/comisionesAnualidad/proceso/Proceso";
import { ProcesoAnualidadStore, procesoAnualidadStore } from "./Proceso.store";
import {
  ProcesoAnualidadDispatcher,
  procesoAnualidadDispatcher
} from "./Proceso.dispatcher";
import Layout from "../../../components/layout";

interface Props extends ProcesoAnualidadStore, ProcesoAnualidadDispatcher {}
interface State {}

@Router()
@ReduxConnect(procesoAnualidadStore, procesoAnualidadDispatcher)
export default class ProcesoAnualidadContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Proceso de Comisiones - Anualidades" />
          <ProcesoAnualidadComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
